import React from 'react';
import { injectIntl } from "react-intl";

import './Benefits.sass';

import hex1 from './hex1.svg';
import hex2 from './hex2.svg';
import hex3 from './hex3.svg';

function Benefit({icon, title, description}) {
  return (
    <div className="benefit">
      <div className="benefit__content">
        <div className="benefit__hexagon">
          <img loading="lazy" src={icon} alt={title}/>
        </div>
        <div className="benefit__header">{title}</div>
        <p className="benefit__text">{description}</p>
      </div>
    </div>
  );
}

@injectIntl
export default class Benefits extends React.PureComponent {
  render() {
    const {intl} = this.props;

    return (
      <div className="benefits">
        <div className="benefits__row">
          <Benefit
            icon={hex1}
            title={intl.formatMessage({id: "section.benefits.online.title"})}
            description={intl.formatMessage({id: "section.benefits.online.description"})}
          />
          <Benefit
            icon={hex2}
            title={intl.formatMessage({id: "section.benefits.experts.title"})}
            description={intl.formatMessage({id: "section.benefits.experts.description"})}
          />
          <Benefit
            icon={hex3}
            title={intl.formatMessage({id: "section.benefits.safe.title"})}
            description={intl.formatMessage({id: "section.benefits.safe.description"})}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/benefits/Benefits.js